/**
 * ContractSlice Validation Reducers
 * 
 * Reducers for managing validation errors.
 */

import { PayloadAction } from '@reduxjs/toolkit';
import { ContractSliceState } from '../state';

/**
 * Set a validation error for a specific field
 */
export const setValidationError = (
  state: ContractSliceState,
  action: PayloadAction<{ field: string; message: string }>
) => {
  state.validationErrors[action.payload.field] = action.payload.message;
};

/**
 * Set all validation errors at once
 */
export const setValidationErrors = (
  state: ContractSliceState,
  action: PayloadAction<Record<string, string>>
) => {
  state.validationErrors = action.payload;
};

/**
 * Clear a validation error for a specific field
 */
export const clearValidationError = (
  state: ContractSliceState,
  action: PayloadAction<string>
) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors = (state: ContractSliceState) => {
  state.validationErrors = {};
};
